/**
 * Hexes for anything Google Maps paints itself — pin bodies, ring fills — which
 * take a literal colour rather than a theme token.
 *
 * The proximity bands share the pin hues on purpose: a ring and the markers
 * inside it stand for the same distance band, so they cannot be allowed to
 * drift apart.
 */
export const PIN_COLORS = {
  blue: "#057B9F",
  green: "#24B388",
  yellow: "#FBBF24",
  red: "#F34A02",
  grey: "#878787",
};

export const PROXIMITY_BAND_COLORS = {
  green: PIN_COLORS.green,
  yellow: PIN_COLORS.yellow,
  red: PIN_COLORS.red,
};
